import {
  billingCycleDependBasePlanTypeList,
  dependMeetingPlanTypeList,
  licenseDependBasePlanTypeList,
  PlanModelInfo,
  planTypes,
  WEBINAR_CATEGORY, WEBINAR_ONE_TIME_CATEGORY,
} from '@/common/constants';
import { defaultMapper } from "@/common/service/default-mapper"
import { $context } from '@/global-install/index';
import { getCapacityByMapCode } from '@/common/service/parse';
import { get as _get } from 'lodash';
import {
  getEnableOnlineRemoveWebinar10000,
  getEnableWebinar300,
  webinarSingleUseAllowed,
} from '@/common/service/op-switch';
import { capacityFormatter } from '@/common/utils';
import { pageConfig } from '@/common/service/page-config';
import { planUnitMap } from '@/common/product-unit';

const isMarketingWebinar100Enable = _get(window, 'campaignFlags.isMarketingWebinar100Enable', true);

let WebinarKey = [
    // WEBINAR_CATEGORY.webinar100,
    // WEBINAR_CATEGORY.webinar300,
    WEBINAR_CATEGORY.webinar500,
    WEBINAR_CATEGORY.webinar1000,
    WEBINAR_CATEGORY.webinar3000,
    WEBINAR_CATEGORY.webinar5000,
    WEBINAR_CATEGORY.webinar10000,
];

export default (planMapJSON, _, subscriptions) => {
    const hasBoughtW300Plan = subscriptions.find(p => p.category === planTypes.WEBINAR && "webinar" + getCapacityByMapCode(p.mapCode) === WEBINAR_CATEGORY.webinar300);
    if (getEnableWebinar300() || ($context.is.edit && hasBoughtW300Plan)) {
      WebinarKey.unshift(WEBINAR_CATEGORY.webinar300);
    }

    const hasBoughtW100Plan = subscriptions.find(p => p.category === planTypes.WEBINAR && "webinar" + getCapacityByMapCode(p.mapCode) === WEBINAR_CATEGORY.webinar100);
    if (
      (isMarketingWebinar100Enable && pageConfig.from === WEBINAR_CATEGORY.webinar100 && $context.is.loggedIn) ||
      ($context.is.switch && !hasBoughtW100Plan) || (hasBoughtW100Plan && $context.is.edit)
    ) {
      WebinarKey.unshift(WEBINAR_CATEGORY.webinar100);
    }

    if (webinarSingleUseAllowed) {
      if ($context.is.buyNow || $context.is.basic2pro || $context.is.add2cart) {
        const isSingleUseProFreeTrial = subscriptions.find(p => p.isSingleUseProFreeTrial);
        if (isSingleUseProFreeTrial) {
          WebinarKey = [];
        }
        // webinar one time
        const webinar = Object.keys(planMapJSON?.['webinar'] ?? {});
        if (webinar.length) {
          WebinarKey.push(...WEBINAR_ONE_TIME_CATEGORY.map(k => `webinar.${k}`));
        }
      }
    }

    const hasBoughtW10000Plan = subscriptions.find(p => p.category === planTypes.WEBINAR && "webinar" + getCapacityByMapCode(p.mapCode) === WEBINAR_CATEGORY.webinar10000);
    if (getEnableOnlineRemoveWebinar10000() && !hasBoughtW10000Plan) {
      WebinarKey = WebinarKey.filter(k => k !== WEBINAR_CATEGORY.webinar10000);
    }

    return WebinarKey.filter(key => !planMapJSON?.disablePlanCategoryList.includes(key)).reduce((pre, key) => {
        const plan = _get(planMapJSON, key, []);
        return [
            ...defaultMapper(plan, planTypes.WEBINAR).map(item => {
              return {
                ...item,
                participants: plan.participants,
                capacity: plan.participants,
                capacityDesc: capacityFormatter(plan.participants),
                typeNameKey: 'billing.webinar.title',
                planNameKey: 'billing.webinar.title',
                dependBasePlanTypeList: dependMeetingPlanTypeList,
                billingCycleDependBasePlanTypeList,
                licenseDependBasePlanTypeList,
                unit: planUnitMap.license,
                planModel: PlanModelInfo.license
              }
            }),
            ...pre,
        ]
    }, []);
}
